
import EmployeeManagementPage from "./employee/EmployeeManagementPage";

const EmployeeManagement = () => {
  return <EmployeeManagementPage />;
};

export default EmployeeManagement;
